import React, { useState, useEffect } from 'react';
import solidbackgroundimg from "../assets/solidbackgroundimg.png";
import { Translate,Languages } from './LanguageChanger';
import LoaderScreen from './LoaderScreen';
import { sendTestMatomoEvent } from '../Analytics/MatomoManager/matomoTest';
let resolution = window.RESOLUTION;
if(window.innerWidth >= 1920 && window.innerHeight >= 1080){resolution = "FHD";}else{resolution = "HD";}
const userAgent = navigator.userAgent.toLowerCase();
if (userAgent.includes('webos') || userAgent.includes('lg') || userAgent.includes('web0s')) {
  resolution = 'FHD';
}

const MyAccount = ({callback, shouldFocus = false, callback1}) => {
  const [state, setState] = useState({
    shouldFocusGrid: shouldFocus,
    loading: true,
    userDetails: null,
    selectedProfile: null,
  });

  // Load user data when component mounts or when localStorage changes
  useEffect(() => {
    const loadUserData = () => {
      const userDetails = JSON.parse(localStorage.getItem("user_details")) || {};
      const myProfile = JSON.parse(localStorage.getItem("myProfile"));
      const updatedMyprofile = localStorage.getItem("updateMyProfile")
        ? JSON.parse(localStorage.getItem("updateMyProfile"))?.data
        : null;
      
      const userProfiles = updatedMyprofile || userDetails?.user_profiles || [];
      
      // Get the selected profile - either from myProfile or first profile
      let selectedProfile = userProfiles[0]; // Default to first profile
      
      if (myProfile && myProfile.profileId) {
        // Find the profile that matches the selected one
        const foundProfile = userProfiles.find(
          profile => profile.profile_id === myProfile.profileId
        );
        if (foundProfile) {
          selectedProfile = foundProfile;
        }
      }

      setState((prevState) => ({
        ...prevState,
        loading: false,
        userDetails: userDetails,
        selectedProfile: selectedProfile,
      }));
    };

    loadUserData();

    // Matomo Event
    sendTestMatomoEvent({ 
      eventCategory: "Page",
      eventAction: "View",
       eventName: "UserDetails", url:"user-details"});
  }, [])

  const styles = {
    MyAccountContainer: {
          
      backgroundImage: `url(${solidbackgroundimg})`,
      display: 'flex',
      flexDirection: 'column',
          // background: 'transparent',
      width: '92vw',
      height: '74vh',    
      backgroundSize: 'cover',
          backgroundPosition: 'center', // Center the background image
          backgroundRepeat: 'no-repeat', // Do not repeat the background image
      color: '#D0D0D0',
      fontSize: '18px'
          
    },
      // };

      // const styles = {
    container: {
          // background: `url(${solidbackgroundimg})` ,
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
          // backgroundColor: "#D0D0D0",
          // color: "#D0D0D0",
      height: "100vh",
      paddingTop: "20px",
      fontFamily: "Arial, sans-serif",
          alignItems:"center"
    },
    avatar: {
      width: "8rem",
      height: "8rem",
      borderRadius: "50%",
      marginBottom: "20px",
    },
    formGroup: {
      width: "100vh",
      maxWidth: "53vh",
      display: "flex",
      flexDirection: "column",
      gap: "15px",
      marginBottom: "20px",
    },
    label: {
      fontWeight: "bold",
          // marginBottom: "5px",
    },
    input: {
      width: "55vh",
      height: "3.2rem",
      padding: "10px",
      borderRadius: "5px",
      backgroundColor: "#0E1653",
      color: "#FFF",
      border: "none",
      outline: "none",
          paddingLeft:"10px"
    },
    row: {
      display: "flex",
      justifyContent: "space-between",
      gap: "27px",
    },
    footer: {
          // color: "#FF6B00",
      fontSize: "20px",
      textAlign: "center",
      marginTop: "35px",

    },
    link: {
          
      color: " #EC008C",
      textDecoration: "underline",
        
    },
    gotomy: {
          fontFamily:"Anek Latin",
          fontWeight:"400",
      fontSize: "20px",
      color: "#A3A3A3",
    }
  };

  const { shouldFocusGrid, loading, userDetails, selectedProfile } = state;

  const handleUPButton = (p) => {
        // console.log("handleUPButton --- = ",handleUPButton);
    shouldFocus = false;
    setState((prevState) => ({
      ...prevState,
      shouldFocusGrid: false
    }));
    callback1(p);
  };
    
      // useEffect(() => {
      //   setState((prevState) => ({
      //     ...prevState,
      //     shouldFocusGrid: shouldFocus
      //   }));
      // }, [shouldFocus]);

  const callBack = (p) => {
        if(p === "Grid"){
      setState((prevState) => ({
        ...prevState,
            shouldFocusGrid:true,
      }));
        }else if(p === "Back"){
      setState((prevState) => ({
        ...prevState,
            shouldFocusGrid:false,
      }));
      callback1("HandleUPButton");
    }
  };

      const gender = JSON.parse(localStorage.getItem("user_details"))?.gender == 1 ? "Male" : JSON.parse(localStorage.getItem("user_details"))?.gender == 2 ? "Female" : JSON.parse(localStorage.getItem("user_details"))?.gender == 3 ? "Other" : "N/A";


  return (
    <div style={styles.MyAccountContainer}>
      {loading && <LoaderScreen />}
      <div style={styles.container}>
      {/* Avatar */}
        <img
          src={selectedProfile?.profile || ""}
          alt="Avatar"
          style={styles.avatar}
        />

        {/* Form Fields */}
        <div style={styles.formGroup}>
          <label style={styles.label}>
            <Translate langKey={'acc-username'}/>
          </label>
          <input 
            type="text" 
            value={selectedProfile?.username || "N/A"} 
            readOnly 
            style={{...styles.input, paddingLeft: "30px"}}  
          />

          <label style={styles.label}>
            <Translate langKey={'Phone-Number'}/>
          </label>
          <input 
            type="text" 
            value={userDetails?.mobile || "N/A"} 
            readOnly 
            style={{...styles.input, paddingLeft: "30px"}} 
          />

        <label style={styles.label}><Translate langKey={'email_address'}/></label>
          <input
            type="email"
            value={userDetails?.email || "N/A"}
            readOnly
          style={{...styles.input,paddingLeft:"30px"}}
          />

          {/* Row for Gender and Date of Birth */}
          <div style={styles.row}>
          <div style={{ flex: 1 ,}}>
            <label style={styles.label}><Translate langKey={'acc-Gender'}/></label>
            {/* <input type="text" value={JSON.parse(localStorage.getItem("user_details"))?.gender || "N/A"} readOnly style={{ ...styles.input, width: "22vh", marginTop: "2vh" }} /> */}
              <div style={{
              position:"absolute",
              display:"flex",
              alignItems:"center",
              paddingTop:"26px",
              width:"22vh",
               height: "3.2rem",}}>
             <img  style={{
              position:"relative",
              height:"18px",
              width:"18px",
              // marginTop:"62px",
              // bottom: "4px",
             right:"-20px"
            }}src={"https://sb.wavespb.com/assets/images/male_white.png"}/>
              </div>
            <input type="text" value={gender} readOnly style={{ ...styles.input, width: "22vh", marginTop: "1.5vh" ,paddingLeft:"50px"}} />
            </div>
            <div style={{ flex: 1 }}>
              <label style={styles.label}>
                <Translate langKey={'acc-dob'}/>
              </label>
              <input 
                type="text" 
                value={userDetails?.dob || "N/A"} 
                readOnly 
                style={{ 
                  ...styles.input, 
                  width: "25.2vh", 
                  marginTop: "1.5vh", 
                  paddingLeft: "30px" 
                }} 
              />
            </div>
          </div>
        </div>

        {/* Footer */}
        <div style={styles.footer}>
          <Translate langKey={'go_to_account'}/> {" "}
        {/* Go to "My Account" on{" "} */}
          <span


            style={
              {
            color: " #EC008C",
            textDecoration: "underline",
            marginLeft: "10px",
                marginRight:"10px"
              }

            }

          >
            www.wavespb.com  
          </span>{" "}
        <Translate langKey={'or'}/> <br/><p><Translate  langKey={'pbApp'}/></p>
      </div>
    </div>
    </div>
      
  );
};
export default MyAccount;